'use strict';

import passbackTemplate from './externalEcommercePassback.html';

var externalEcommercePassbackController = function ($controller, $location, $state, workflowService) {
    var vm = this;
    vm.executionStep = null;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function () {
        // Parse ticketId and stepId from URL
        var params = $location.search();
        vm.ticketId = params.ticketId;
        vm.ticketStepId = params.ticketStepId;

        // Validate required parameters
        if (!vm.ticketId || !vm.ticketStepId) {
            vm.error('Missing required parameters: ticketId and ticketStepId are required', false);
            return;
        }

        // Check for error from external system
        if (params.error) {
            console.warn('External ecommerce error:', params.error);
            // Log but continue processing - complete step with what we have
        }

        completePassback();
    };

    function completePassback() {
        // Get all query parameters to send to API
        var passbackParams = $location.search();

        // Call API to process passback on the backend
        workflowService.processExternalEcommercePassback(vm.ticketId, vm.ticketStepId, passbackParams)
            .then(function () {
                // After successful passback processing, transition to next step
                return workflowService.getTicketStepWithTicketStepID(vm.ticketId, vm.ticketStepId);
            })
            .then(function (ticketStep) {
                vm.executionStep = { ticketStep: ticketStep };
                vm.setExecutionStep(vm.executionStep);
                vm.transition();
            })
            .catch(function (error) {
                vm.error('Failed to process passback: ' + (error.data ? error.data.error : error.message), false);
            });
    }
};

externalEcommercePassbackController.$inject = ['$controller', '$location', '$state', 'workflowService'];

export var externalEcommercePassbackComponent = {
    name: 'externalEcommercePassback',
    template: passbackTemplate,
    controller: externalEcommercePassbackController,
    bindings: {}
};

export var externalEcommercePassbackRoute = {
    name: 'externalEcommercePassback',
    url: '/externalEcommercePassback',
    component: 'externalEcommercePassback'
};
